/**
 * Meanbook Note - Firebase Configuration & Initialization
 * ESM Firebase SDK v10.8+ via npm with IndexedDB Multi-Tab Persistence
 */

import { initializeApp } from "firebase/app";
import { 
  getFirestore, 
  initializeFirestore, 
  persistentLocalCache, 
  persistentMultipleTabManager 
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { 
  getAuth, 
  signInWithPopup, 
  signInWithRedirect, 
  GoogleAuthProvider, 
  signOut, 
  onAuthStateChanged, 
  signInWithEmailAndPassword, 
  sendPasswordResetEmail 
} from "firebase/auth";
import { getMessaging } from "firebase/messaging";

// Firebase Configuration จากโปรเจกต์เดิม
const firebaseConfig = {
  apiKey: "AIzaSyDNcW7q3s4ZPc2vWAsvsZiFQxoynle0654",
  authDomain: "meanbook-note.firebaseapp.com",
  projectId: "meanbook-note",
  storageBucket: "meanbook-note.firebasestorage.app",
  messagingSenderId: "1051413658466",
  appId: "1:1051413658466:web:bd07690c252c7bd44f8a3b"
};

// เริ่มต้นเปิดการเชื่อมต่อ Firebase
const app = initializeApp(firebaseConfig);

// เปิดใช้งาน IndexedDB Persistent Multi-Tab Cache เพื่อประหยัด Firestore Reads และรองรับ Offline
let db;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
  });
} catch (err) {
  console.warn("[Firebase] initializeFirestore multi-tab cache warning, fallback to default:", err);
  db = getFirestore(app);
}

const storage = getStorage(app);
const auth = getAuth(app);
let messaging = null;
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  try {
    messaging = getMessaging(app);
  } catch (err) {
    console.warn("[Firebase] Messaging not supported in this environment:", err);
  }
}

export { 
  db, 
  storage, 
  auth, 
  messaging, 
  signInWithPopup, 
  signInWithRedirect, 
  GoogleAuthProvider, 
  signOut, 
  onAuthStateChanged, 
  signInWithEmailAndPassword, 
  sendPasswordResetEmail 
};
export default app;
